"use strict";

const TouchscreenDesigns = () => {
    const init = () => {
        if($('.js-touchscreen-designs').length > 0) {
            var delayDisplay = 500;
            var housesLoading = false;
            var $form = $('.js-touchscreen-designs-form');
            var $formInputs = $('.js-touchscreen-designs-form input');

            $(function() {
                $form.find('.ajax-submit').trigger('click');
            });
            
            window.openDropdown = function(t){
                t.parent().addClass('open');
            }
            window.openDropdown2 = function(t, num){
                t.parent().parent().find('.dropdown').addClass('hide');
                t.parent().parent().parent().addClass('hideLabels adjustForFilters');
                t.parent().addClass('open');
                $('.dropdown.grey').addClass('highlighted');
                $formInputs.filter('[name="storeys"]').val(num);
                $form.find('.ajax-submit').trigger('click');
            }
            window.closeDropdown = function(t){
                t.parent().removeClass('open');
            }
            window.closeDropdown2 = function(t){
                t.parent().removeClass('open');
                t.parent().parent().parent().removeClass('hideLabels adjustForFilters');
                t.parent().parent().find('.dropdown').removeClass('hide');
                $('.dropdown.grey').removeClass('highlighted');
                $formInputs.filter('[name="storeys"]').val(0);
                $form.find('.ajax-submit').trigger('click');
            }
            
            $('.sidebar .options .dropdowns').scroll(function (event) {
                if($(this).scrollTop() == 0){
                $(this).find('.fade.top').hide();
                }else{
                $(this).find('.fade.top').show();
                }
            });
            
            $('.filter .label').click(function () {
                if($(this).parent().hasClass('open')){
                    $('.filter').removeClass('open');
                }else{
                    $('.filter').removeClass('open');
                    $(this).parent().addClass('open');
                }
            });
            
            $('.filter .option').click(function () {
                var $parent = $(this).parent().parent();
                $parent.find('.label .value').text(': '+$(this).text());
                $parent.removeClass('open');
                if($parent.attr('id') == 'lotwidth'){
                    $formInputs.filter('[name="lot_width_min"]').val($(this).data('min'));
                    $formInputs.filter('[name="lot_width_max"]').val($(this).data('max'));
                }else if($parent.attr('id') == 'housesize'){
                    $formInputs.filter('[name="total_area_sq_min"]').val($(this).data('min'));
                    $formInputs.filter('[name="total_area_sq_max"]').val($(this).data('max'));
                }else{
                    $formInputs.filter('[name="'+$parent.attr('id')+'"]').val($(this).data('id'));
                }
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Home Designs Filter - '+$parent.find('.label .default').text()+' '+$(this).text()
                });
                $form.find('.ajax-submit').trigger('click');
            });
            
            $('.designs .houses').scroll(function (event) {
                if($(this).scrollTop() == 0){
                $(this).parent().find('.fade.top').hide();
                }else{
                $(this).parent().find('.fade.top').show();
                }
            });
            
            window.clearFilters = function(){
                $('.filter .label .value').text('');
                $formInputs.filter('[name!="storeys"]').val(0);
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Home Designs Filter - Clear Filters'
                });
                $form.find('.ajax-submit').trigger('click');
            }
        }
    };

    return {
        init:init
    };
};

export default TouchscreenDesigns;